import styled from "styled-components";
import { Menu, Select as S } from "antd";
import { opacity } from "../Services/Sales/Checkout/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  min-height: 60vh;
  padding-top: calc(72px + 24px);
  padding-left: 90px;
  padding-right: 90px;
  padding-bottom: 50px;
  gap: 28px;
`;

export const Card = styled.div`
  background: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 1px 8px 20px 0px #c1c6cd17, -1px -1px 4px 0px #c1c6cd14;
  width: 880px;
  text-align: center;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  margin: 0 auto;
  animation: ${opacity} 1s;
`;

export const Title = styled.h2`
  font-family: "Open Sans";
  font-weight: 700;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: #002244;
  margin-bottom: 8px;
`;

export const Subtitle = styled.p`
  font-family: "Inter", sans-serif;
  font-size: 18px;
  color: #62748e;
  margin-bottom: 32px;
  line-height: 100%;
`;

export const DropdownContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const DropdownButton = styled.button`
  width: 100%;
  padding: 12px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 15px;
  color: #495057;
  background-color: white;
  text-align: left;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    border-color: #adb5bd;
  }
`;

export const DropdownIcon = styled.span`
  font-size: 16px;
  color: #495057;
`;

export const StyledMenu = styled(Menu)`
  max-height: 200px; /* Define a altura máxima */
  overflow-y: auto; /* Adiciona o scroll vertical */
  min-width: 200px; /* Ajusta a largura mínima para o alinhamento com o botão */
`;

export const Select = styled(S)`
  width: 100%;

  .ant-select-selector {
    padding: 12px !important;
    height: 66px !important;
    border-radius: 10px !important;
    border-width: 1.5px !important;
    display: flex !important;
    align-items: center !important;
    /* padding: 12px !important; */
  }

  .ant-select-selection-search {
    display: flex !important;
    align-items: center !important;
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    font-family: "Inter" !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 150% !important;
    letter-spacing: 0px !important;
    text-align: start !important;
  }

  .ant-select-arrow {
    transition: all 300ms ease-in-out;
  }

  &.ant-select-open .ant-select-arrow {
    transform: rotate(180deg) !important;
  }
`;

export const NoData = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #62748e;
  font-family: "Inter";
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0px;
  gap: 16px;
  animation: ${opacity} 300ms ease-in;
`;
